export default __webpack_public_path__ + "static/media/Landing-P2-Ulet-IfansastiGreenpeace.949932bb.jpg";